module.exports = __webpack_public_path__ + "img/mob_signout_button.edf57be5.svg";